import { FC, ReactNode } from 'react'
import { AudienceTag, AudienceTagType } from './Tag'
import { AudienceUsersCount, AudienceUsersCountType } from './UsersCount'

const Audience: FC &
  AudienceTagType &
  AudienceUsersCountType = (): ReactNode => <></>

Audience.Tag = AudienceTag
Audience.UsersCount = AudienceUsersCount

export default Audience
